import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Award } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
import pic1 from "../../../assets/images/Social Media.jpg";

const SocialMedia = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-gray-100 text-gray-800" style={{ marginTop: "80px" }}>
      <motion.header
        className="bg-blue-900 text-white py-16 text-center shadow-lg rounded-lg"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">
                  📲 Social Media Marketing by{" "}
                </span>
                <span className="text-blue-600"> Right On Time Services</span>
              </h1>
              <p className="mt-4 mb-4 font-bold">
                You Run the Business — We Handle the Buzz
              </p>
              <p className="text-white mb-8">
                Your brand’s story should echo through every post, every
                comment, and every share. At Right On Time Services, we bring
                consistency, creativity, and strategy together to build a
                powerful and cohesive digital presence—while you focus on
                growing your business.
              </p>
            </div>
          </div>
        </div>
      </motion.header>

      <section className="py-16 bg-white px-4 md:px-10" data-aos="fade-up">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-center">
          {/* Left Content */}
          <div className="text-left">
            <h2 className="text-3xl font-bold text-blue-900">
              🤝 Meet Your Digital Growth Partner
            </h2>
            <p className="mt-4 max-w-xl">
              Social media isn’t just about likes and shares—it’s about building
              meaningful relationships, driving sales, and shaping perception.
              With billions of users across platforms like Instagram, Facebook,
              LinkedIn, and TikTok, there’s never been a better time to make
              your voice heard.
            </p>
          </div>

          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="flex justify-center"
          >
            <img
              src={pic1} // ← Replace with your actual image path
              alt="Digital Growth Partner Illustration"
              className="w-full max-w-md h-auto object-contain rounded-xl"
            />
          </motion.div>
        </div>
      </section>

      <section className="py-16 bg-white" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          {/* 🔍 Our End-to-End SEO Services */}
        </h2>
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-8 px-8 mt-6"
          style={{ marginTop: "30px" }}
        >
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              🎯 Social Media Strategy: Your Roadmap to Growth
            </h3>
            <p className="mt-2">
              Before we publish a single post, we dive deep into your brand,
              audience, and industry. Our strategic planning includes:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Defining goals and KPIs</li>
              <li>● Identifying your target audience</li>
              <li>● Selecting the most effective platforms</li>
              <li>● Conducting competitor analysis</li>
              <li>Crafting a distinctive brand voice</li>
            </ul>
            <p className="mt-2">
              The result? A unique strategy that positions you ahead of the
              competition.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              ✍️ Content Creation That Captivates
            </h3>
            <p className="mt-2">
              Great content builds trust, sparks engagement, and drives action.
              Our creative team delivers:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Engaging social media posts</li>
              <li>● Eye-catching graphics and branded visuals</li>
              <li>● Short-form videos and reels</li>
              <li>● Blog content that supports your campaigns</li>
            </ul>
            <p className="mt-2">
              Each piece is designed to reflect your brand’s personality and
              connect emotionally with your audience.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              📢 Social Media Advertising That Converts
            </h3>
            <p className="mt-2">
              Want more eyes on your content? We create high-performing ad
              campaigns designed to grow your audience and boost your ROI. Our
              advertising services include:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>
                ● Targeted campaign creation (Meta, LinkedIn, TikTok, etc.)
              </li>
              <li>● A/B testing and audience segmentation</li>
              <li>● Continuous performance optimization</li>
              <li>● Conversion tracking and reporting</li>
            </ul>
            <p className="mt-2">We don’t just push ads—we drive results.</p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              📊 Real-Time Monitoring & Data-Driven Insights
            </h3>
            <p className="mt-2">
              Analytics are at the heart of smart social media growth. We track:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Engagement metrics (likes, comments, shares)</li>
              <li>● Follower growth</li>
              <li>● Click-through and conversion rates</li>
              <li>● Best-performing content</li>
            </ul>
            <p className="mt-2">
              Our monthly reports give you full visibility into performance, so
              you always know what’s working—and what’s next.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              💬 Reputation Management That Protects Your Brand
            </h3>
            <p className="mt-2">
              Negative comments or reviews can quickly impact your brand’s
              credibility. We proactively monitor your accounts and:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Respond to comments and inquiries promptly</li>
              <li>● Address negative feedback professionally</li>
              <li>● Highlight positive testimonials</li>
              <li>● Maintain a strong, trustworthy brand voice</li>
            </ul>
          </motion.div>
        </div>
      </section>

      <motion.section
        className="py-16 text-center bg-white rounded-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        data-aos="fade-up"
      >
        <section className="py-20 bg-white px-4 md:px-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-blue-700 mb-6">
              🚀 Ready to Grow? Let’s Start Together
            </h2>
            <p className="text-gray-700 text-md mb-4">
              Social media should work for your business—not add stress to your
              day. Partner with Right On Time Services and get a dedicated team
              committed to growing your brand online with clarity, creativity,
              and consistency.
            </p>

            <p className="text-lg font-semibold text-blue-800">
              📞 Contact us now to schedule your free consultation and kickstart
              your digital journey.
            </p>
          </div>
        </section>
      </motion.section>
    </div>
  );
};

export default SocialMedia;
